import React from 'react';
import {SimpleGrid} from '@chakra-ui/react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiBox, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';
import {ACNE_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire4Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === ACNE_TELECONSULTATION_KEYS.SKINCARE_GOALS);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[ACNE_TELECONSULTATION_KEYS.SKINCARE_GOALS]?.data,
  );

  const {inputs, setInputs} = useInput<{selectedOptions: string[]}>({
    selectedOptions: currentAnswer?.selectedOptions || [],
  });

  const onClickSubmit = () => {
    dispatch(
      setQuestionnaireAnswer({
        key: ACNE_TELECONSULTATION_KEYS.SKINCARE_GOALS,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: ACNE_TELECONSULTATION_KEYS.SKIN_TYPE}));
  };

  const onClickOption = (valueOption: string) => {
    if (inputs.selectedOptions.includes(valueOption)) {
      setInputs({
        selectedOptions: inputs.selectedOptions?.filter(el => el !== valueOption),
      });
    } else {
      setInputs({
        selectedOptions: [...inputs.selectedOptions, valueOption],
      });
    }
  };

  return (
    <UiQuestionnaireLayout
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
      actions={questionnaire?.actions}
      disableNext={!inputs.selectedOptions.length}
    >
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.small} />
        <UiText fontSize="xl" fontWeight="bold" mt={spacing.medium}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText fontSize="sm" opacity={0.8} my={4}>
          Select all that apply
        </UiText>
        <SimpleGrid columns={2} mt={5} spacing={5} w="100%">
          {questionnaire?.options?.map((value, index) => (
            <UiBox key={`${value.label}-${value.value}`}>
              <ScrollToBottomButton
                key={`${value.label}-${value.value}`}
                title={value.label}
                variant={inputs.selectedOptions?.includes(value.value as string) ? 'solid' : 'toggle'}
                onClick={() => onClickOption(value.value as string)}
                height="35px"
                w="100%"
              />
            </UiBox>
          ))}
        </SimpleGrid>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire4Screen;
